import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorService } from '@eforall/common';


@Component({
	selector: 'dashboard-error-generic-data-part',
	imports: [],
	templateUrl: './error-generic-data.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./error-generic-data.part.scss']
})
export class DashboardErrorGenericDataPart implements OnInit {

	private router = inject(Router);
	private errorService = inject(ErrorService);

	background = 'transparent';
	activity? = '';
	name? = '';
	message? = '';
	stack? = '';


	ngOnInit() {
		const details = this.errorService.snapshot;
		if (details.error) {
			this.background = 'darkred';
			this.activity = details.activity;
			this.name = details.name;
			this.message = details.message;
			this.stack = details.stack;
		}
		else {
			this.background = 'darkgreen';
			this.activity = 'Normal Activity';
			this.name = 'No Error';
			this.message = 'Everything is hunky dory!';
			this.stack = '';
		}
	}

	goBack() {
		this.errorService.clearError();
	}

	goToDashboard(): void {
		this.errorService.clearError();
		this.router.navigate(['/']);
	}

}